function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.59,9.08S298.77-1.5,365,58.75s85.49,155.34,103.14,232-16.69,143.2-81.57,162.79S292.73,417,212.1,397s-105-13.21-162.3-73.76S4,151.77,74.59,83.29,215.59,9.08,215.59,9.08Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,9.08S298.77-1.5,365,58.75s85.49,155.34,103.14,232-16.69,143.2-81.57,162.79S292.73,417,212.1,397s-105-13.21-162.3-73.76S4,151.77,74.59,83.29,215.59,9.08,215.59,9.08Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-135"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 456.62,
    y1: 342.75,
    x2: 47.2,
    y2: 313.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.21,
    y1: 315.14,
    x2: 68.21,
    y2: 269.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.91,
    y1: 317.6,
    x2: 106.91,
    y2: 272.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.75,
    y1: 321.28,
    x2: 151.75,
    y2: 275.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.51,
    y1: 324.97,
    x2: 201.51,
    y2: 276.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.1,
    y1: 328.04,
    x2: 253.1,
    y2: 276.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.7,
    y1: 330.5,
    x2: 304.7,
    y2: 281.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.69,
    y1: 337.53,
    x2: 359.69,
    y2: 284.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.02,
    y1: 339.71,
    x2: 422.02,
    y2: 288.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.62,
    y1: 349.93,
    x2: 45.88,
    y2: 319.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.73,
    y1: 470.57,
    x2: 456,
    y2: 472,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 424,
    x2: 430.01,
    y2: 468.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "459 278.69 58.62 261.52 58.62 43.32 459 26.15 459 278.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.12 266.8 66.04 251.87 66.04 52.98 449.12 38.04 449.12 266.8",
    style: {
      fill: "none",
      stroke: "#0D6EFD",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,75.53l-106,3a4.7,4.7,0,0,1-4.55-5h0c0-2.83,2-5.19,4.55-5.27l106-3.47A5,5,0,0,1,195.42,70h0A5.35,5.35,0,0,1,190.47,75.53Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81,72.15a4.78,4.78,0,0,0-4.7-5.06L84.48,68.32c-2.51.08-4.55,2.44-4.55,5.27a4.7,4.7,0,0,0,4.55,5l37.63-1.09A5.14,5.14,0,0,0,126.81,72.15Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,96.4l-106,2.21c-2.51.06-4.55-2.19-4.55-5h0a5,5,0,0,1,4.55-5.23l106-2.64a5,5,0,0,1,4.95,5.22h0A5.3,5.3,0,0,1,190.47,96.4Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,91.91h0a4.89,4.89,0,0,0-4.79-5.15l-64,1.6a5,5,0,0,0-4.55,5.23h0c0,2.83,2,5.08,4.55,5l64.05-1.34A5.16,5.16,0,0,0,153.32,91.91Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,117.26l-106,1.39a4.78,4.78,0,0,1-4.55-5.06h0a5,5,0,0,1,4.55-5.19l106-1.82a5.06,5.06,0,0,1,4.95,5.27h0A5.24,5.24,0,0,1,190.47,117.26Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,112.2a5,5,0,0,0-4.86-5.22L84.48,108.4a5,5,0,0,0-4.55,5.19,4.78,4.78,0,0,0,4.55,5.06l82.66-1.08A5.19,5.19,0,0,0,172,112.2Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,138.13l-106,.56a4.82,4.82,0,0,1-4.55-5.09h0a4.91,4.91,0,0,1,4.55-5.16l106-1a5.1,5.1,0,0,1,4.95,5.3h0A5.2,5.2,0,0,1,190.47,138.13Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,74.76l-14.52.42a5,5,0,0,1-5-5.21h0a5.39,5.39,0,0,1,5-5.52L217.1,64a5,5,0,0,1,5.05,5.24h0A5.42,5.42,0,0,1,217.1,74.76Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,95.84l-14.52.3a5,5,0,0,1-5-5.25h0a5.34,5.34,0,0,1,5-5.48l14.52-.36a5.08,5.08,0,0,1,5.05,5.28h0A5.37,5.37,0,0,1,217.1,95.84Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,116.91l-14.52.19a5.09,5.09,0,0,1-5-5.29h0a5.29,5.29,0,0,1,5-5.44l14.52-.25a5.14,5.14,0,0,1,5.05,5.32h0A5.31,5.31,0,0,1,217.1,116.91Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,138l-14.52.07a5.14,5.14,0,0,1-5-5.33h0a5.24,5.24,0,0,1,5-5.4l14.52-.13a5.17,5.17,0,0,1,5.05,5.35h0A5.28,5.28,0,0,1,217.1,138Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.31,
    y1: 62.94,
    x2: 102.37,
    y2: 62.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.31,
    y1: 83.96,
    x2: 102.37,
    y2: 83.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.31,
    y1: 103.91,
    x2: 102.37,
    y2: 103.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.31,
    y1: 124.93,
    x2: 102.37,
    y2: 124.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.9,
    y1: 63.51,
    x2: 415.2,
    y2: 63.07,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.59,
    y1: 75.83,
    x2: 415.2,
    y2: 75.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.9,
    y1: 87.7,
    x2: 415.2,
    y2: 87.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.81,
    y1: 99.69,
    x2: 415.2,
    y2: 99.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.9,
    y1: 111.9,
    x2: 415.2,
    y2: 111.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.08,
    y1: 124.03,
    x2: 415.2,
    y2: 123.85,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.9,
    y1: 136.09,
    x2: 415.2,
    y2: 136.01,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.97,
    y1: 148.2,
    x2: 415.2,
    y2: 148.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.9,
    y1: 160.28,
    x2: 415.2,
    y2: 160.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,63l4.34-.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,75.13l4.34-.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,87.3l4.34-.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,99.47l4.22-.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,111.64l4.34-.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,123.82l4.25,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,136l4.34,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.92,148.16h4.37",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,160.33h4.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,62.69l7.43-.23",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,74.9l7.43-.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,87.11l7.43-.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.72,99.31l7.24-.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,111.52l7.43-.1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.69,123.73l7.27-.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,135.94l7.43,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,148.15H435",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,160.36l7.43,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.09,
    y1: 150.58,
    x2: 382.51,
    y2: 150.48,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.09,
    y1: 141.33,
    x2: 382.51,
    y2: 140.73,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.09,
    y1: 132.07,
    x2: 382.51,
    y2: 130.98,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,169.71v-44s-3.41-4.33-17.48-3.53c-13.92.8-17.26,13.1-32,20.26S312,138.05,300,138.11s-17.85,13.34-26.46,18.37-16.18-.65-26.41.58a14.54,14.54,0,0,0-12.36,10.52l-.14,1.24Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,169.71V145.55c-4.81-.26-14.79.54-25.39,9.37s-29.51,4.17-35.07,2.14c-8.85-3.24-19-3.4-29.09,3s-18.29,5.78-27.64,5.73c-6.61,0-14.28,2-18.15,3.11Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.77,238.26l-25.87-.81a4.68,4.68,0,0,1-4.38-4.77h0a4.36,4.36,0,0,1,4.38-4.51l25.87.71a4.75,4.75,0,0,1,4.48,4.82h0A4.44,4.44,0,0,1,271.77,238.26Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,239.88l-26.86-.83a4.82,4.82,0,0,1-4.54-4.87h0a4.48,4.48,0,0,1,4.54-4.59l26.86.74a4.88,4.88,0,0,1,4.65,4.91h0A4.55,4.55,0,0,1,324,239.88Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,241.54l-27.88-.87a4.94,4.94,0,0,1-4.71-5h0a4.6,4.6,0,0,1,4.71-4.68l27.88.77a5,5,0,0,1,4.82,5h0A4.68,4.68,0,0,1,377.1,241.54Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 213.16,
    x2: 223.17,
    y2: 216.55,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 205.55,
    x2: 223.17,
    y2: 208.52,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 197.94,
    x2: 223.17,
    y2: 200.48,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 190.32,
    x2: 223.17,
    y2: 192.44,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 182.71,
    x2: 223.17,
    y2: 184.41,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 175.1,
    x2: 223.17,
    y2: 176.37,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 167.49,
    x2: 223.17,
    y2: 168.33,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.75,
    y1: 159.88,
    x2: 223.17,
    y2: 160.3,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.05 221.8 83.31 221.43 83.31 191.25 97.05 191.46 97.05 221.8",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.54 222.32 102.59 221.95 102.59 183.02 116.54 183.19 116.54 222.32",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.33 222.85 122.17 222.47 122.17 176.57 136.33 176.71 136.33 222.85",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.42 223.39 142.04 223.01 142.04 157.53 156.42 157.56 156.42 223.39",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.82 223.94 162.22 223.55 162.22 176.94 176.82 177.08 176.82 223.94",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.54 224.5 182.71 224.1 182.71 191.78 197.54 192 197.54 224.5",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.59 225.06 203.52 224.66 203.52 204.88 218.59 205.17 218.59 225.06",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.96,
    y1: 229.05,
    x2: 95.14,
    y2: 229.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.38,
    y1: 229.63,
    x2: 114.73,
    y2: 229.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.09,
    y1: 230.22,
    x2: 134.62,
    y2: 230.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.11,
    y1: 230.81,
    x2: 154.81,
    y2: 231.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.44,
    y1: 231.42,
    x2: 175.32,
    y2: 231.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.08,
    y1: 232.04,
    x2: 196.15,
    y2: 232.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.05,
    y1: 232.66,
    x2: 217.31,
    y2: 233.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 181.05 394.37 173.87 413.88 174.02 413.88 181.24 394.37 181.05",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 191.09 394.37 183.92 419.39 184.19 419.39 191.43 394.37 191.09",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 201.13 394.37 193.96 423.7 194.38 423.7 201.63 394.37 201.13",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 211.18 394.37 204 436.07 204.75 436.07 212.03 394.37 211.18",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 221.22 394.37 214.05 423.7 214.67 423.7 221.92 394.37 221.22",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 231.26 394.37 224.09 414.49 224.59 414.49 231.81 394.37 231.26",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 241.31 394.37 234.13 406.55 234.48 406.55 241.68 394.37 241.31",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.24,199.15c0,12.2-9.42,21.85-20.95,21.56s-20.63-10.25-20.63-22.26,9.2-21.67,20.63-21.57S279.24,187,279.24,199.15Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.28,176.94c-.33,0-.65-.06-1-.06-11.43-.1-20.63,9.56-20.63,21.57s9.2,22,20.63,22.26c.34,0,.66,0,1,0Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,199c0,8.4-6.48,15.07-14.43,14.89S244,206.87,244,198.56s6.38-15,14.28-14.89S272.72,190.64,272.72,199Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,200c0,12.42-9.77,22.25-21.73,21.95s-21.41-10.45-21.41-22.68,9.54-22.07,21.41-22S331,187.6,331,200Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.19,199.91a14.85,14.85,0,0,1-15,15.16c-8.21-.18-14.82-7.19-14.82-15.66a14.85,14.85,0,0,1,14.82-15.16C317.46,184.34,324.19,191.35,324.19,199.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.63,200.93a22.11,22.11,0,0,1-22.57,22.37,23.06,23.06,0,0,1-22.22-23.12,22.13,22.13,0,0,1,22.22-22.37A23,23,0,0,1,384.63,200.93Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.13,177.87c-.36,0-.71-.06-1.07-.06a22.13,22.13,0,0,0-22.22,22.37,23.06,23.06,0,0,0,22.22,23.12c.36,0,.71,0,1.07,0Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.61,200.81a15.27,15.27,0,0,1-15.55,15.45,15.92,15.92,0,0,1-15.38-16,15.28,15.28,0,0,1,15.38-15.44A15.89,15.89,0,0,1,377.61,200.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.85,
    y1: 199.82,
    x2: 263.35,
    y2: 199.99,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.81,
    y1: 200.7,
    x2: 314.67,
    y2: 200.87,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.74,
    y1: 201.6,
    x2: 366.97,
    y2: 201.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.25 83.38 305.32 82.62 305.1 82.84 305.25 83.38 305.25 83.38",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.75 94.59 276.26 94.67 277.43 94.31 275.75 93.77 275.98 94.32 275.3 94.48 275.75 94.59 275.75 94.59",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,103.89l-2.58-1-.46.27.07-.39-.83-.56-.95.4.31-.47-.71-.2-.23.32.44-.85-.54-1.19-.61-.53-1.36-.18h0l-1-1-.51,0,.09-.33-.52-.21,0-.23-.29-.09-.68.29-1.12-.29-.57-.53-.1.26-.48.33.12.58-.37-.13.15-.53-.05-.28.09-.08.09-.25-1,.55-.17,0-.8,1.21-.07,0-.22-.32-.49-.25-.5.22h-.56l-.57-.75.21-1.67-.39-.31-1.4,0h0l-.14-.09.21-.88.07,0h0l.41-1.34-.85,0-.78,1.21-1.08.19-.4-.21-.57-.92V91.48l-.14-.06.14.06-.1-.51.09-.39,1.19-.93,1.16.26.16-.14.31.24-.15-.42.55-.26.14.11.46-.08.33.26.24,0,.33-.13.88,2,.27,0,.15-.48-.49-2,1.59-1.79,0-.26.09-.15h.24l.09-.24-.24-.41v-.19l-.23-.34.14-.14,0-.53h.12l.06.87.16-.12.07-.7.25,0,.18-.51.71-.29h-.53l.56-.22.18-.17.29,0-.09-.31.27-.65.46-.45h.44l1-.77,0,.17.32.13-.71.37,0,.45.46-.11.33-.34.81-.27L280,82l.47-.21-.13-.16v-.28l-.57.58-.62-.11-.38-.34,0-.42-.16-.13,0-.16.35-.52-1.52.32-.77.77.88-1.16.37-.13.26-.36,2.2-.19,1.6-1,0-.17-.1-.11L282,78l-.19-.31-.37.07,0-.33-.89.35-.08-.16.91-.43-1.71-1.08,0-.11.28-.18-1.1-2-.32.42-.12.47-.12.15-.21,0-.35.25-.58-.51L277,73.9l.12-.35-.8-.25-.73-.66-.35.14-1.07-.14-.15.3.23.27-.19.39.24.59-.35.86.52.47.08.88L274,77l-.49.22.28,1.27-.07.34.05.2h-.16l-.19.26-.29-.12-.62-.9,0-.93-.2-.25-2.9-1.14-.52.19,0-.2-.41-.84-.38-.1.22-1.43,1.19-1.27-1.06-.47,1.21.2.09-.35.51.08.5-.6-.88-.41,0-.22.7.37.52-.45-.2-.23.27-.14.23.18.37,0-.19-.28.06-.11L272,70h.3l.52-.44-.29-.72v-.17l.35-.15-.21-.41-1.21-.36,0,.38.11.2-.06.18-.23.18-.17.41-.15-.25-.05.32.13.24-.24.21-.43-.59.15-.18V68.6l-.23-.27-.33-.08-.29.62-.11-.48.13-.33-.35-.15-.26.08v-.34l.2-.09-.52-.46v-.35l-.45-.35-.08-.17.25-.22.08-.4.54,0,.51-.81-.94-.29-.73.15.1.24-.23,0,.19,1.37-.21.24.11.23-.29,0,0,1.08.7.27-.12.53.17-.15.16.22-.58.42v.39l-.19.15-.18-.32,0-.31-.4-.12.26-.06.18-.16.4-.05-.19-.34-.28,0,.29-.07-.6-.22-.75.4.57.42-.3.22,0,.26-1.92-.1-.31-.17-.18-.31-.57,0-.51.28.16.16.78-.3-.57.36,0,.86-.22-.1,0-.33L261,69.49l.39-.32-.13-.3-2.25-.59-1.18.24v-.26l-.11-.31-.47.58-.52-.78-.21.08-.38.5-1.43.74.08-.22,1.22-.78-.3,0-1.18.57-.26-.14-.47.41.14.23L248.12,68l-.11-.2-.59,0-.17-.16-.44.12.13-.18-.27-.14-1.22.54.08.21-.76.1-.4.4-.14.43-.87.22-.09.26.94.94h.58l.11.34.37.08-1.14.24V71l-.43,0-.19.24-.3,0-.46.32.5.22-.07.19.26.29h1l.61-.27-.1.28,0,.53-.42.05-.18.33L244,73.1l-.14.41-.34.3-.17.36.31.23v.38l.42.46.41-.09.17-.17.11.85,1.06,0,.14-.21.37,0-.11.83-1,1-.53.08-.25.44,3.27-2.39-.27-.15,1.21-1.33.21.09v.15l-.35.09-.14.37,0,.29-.12.18.14.13.68-.45.49,0v-.21l-.15-.23.11-.2.71.14-.15.14,0,.14.48-.11.07.07,1.14.09.31.23.42-.17-.07.25,1,.72.2-.2.28.16,0-.34.13,0,0,.52-.26-.06-.23.08.55.88,0-.7.05.28.2-.14V76l.2.27-.11.28-.19.11,0,.42.14-.15.22-.06.3.26-.14-.19v-.22l.26.39-.17.21-.3-.16.05.7.12-.14.19.08.08-.23.17.07.16-.1,0,.28.15,0v0l.15.2-.1.17.06.3.3,0,.08.23.43.33.08.62.91.41.13.24.47.15.3.42.06.41-.11.41-.16-.59,0-.17-1-.87-.82-.15,1.1,1,.49,1.15.05,3.8,1.16,1.93.72.26,1.48,2.71-.28,0,.81.62.1.5.77.91.17-.13-.07-.32-.3-.14-1-1.94,0-.21-.27-.13-.31-.9.13,0,.53.2.13,1,2.58,3.24v.3l-.11.14.28.5,2.53,1.32,1.34,0,.37.33h0l.39.37,1.17.35.12-.06h.1l.09.3.54.62,0,.16.09.35.2-.05,1.4,1,.27-.09-.1-.22.18-.2.39-.15.42.81.06,1.51-.54.71v.05l-.24.15L273,103l.21.21.17,0-.16.25h0l-.29.35.14.55-.11.11,1.86,3.56,2,1.5-1.45,11,.16.27.16-.73.13-.15.09.15-.13,1.71-.18.12,0,.26-.22-.1.15-.27-.18-.29.11.32-.39.27,0,.19-.22.25.45,0,0,.2-.11.25.33,0v.16l-.44,0-.24.22.13.18.18-.13.14,0-.36.42.16.29.26-.35-.1.59-.21.26V125l.36-.06.07.14-.16.19.21,0,.12,0,.22.09-.31.15-.1.24.26-.1.54,0-.64.27V126l.72-.24-.45.37-.37,0,0,.27.53.18-.06-.14.72-.79-.1.43.32,0-.2.18,0,.28-.15-.33-.07.25-.17-.07-.27.32.26.06.17.36.13-.32.25.37.12-.14.37.3,0-.27,1.09-.2-1.1-.83,0-.17-.13-.22h0l-.31-.16,0-.06.33,0-.22-.68.07-.37,1.06-1.3.07-.4-.35-.1-.25-.61.58-.39.43-1.2.2.13.14-.31-.25.07-.19-.1-.07-.68.56.16.41-.24v-.67l.13-.16.9-.07.67-.39.32-.53-.65-1.13.12,0,.6.2.8-.09,1.09-2,0,.51.81-1.23.21-1.49,1.38-1,.91-.12,1-2.15.09-2,.07-.12.22.07,1.11-1.74-.07-1.17-.31-.23ZM277.31,127v0Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.36 93.73 273.01 92.54 271.77 93.07 272.37 92.74 274.05 93.47 274.22 93.79 275.36 93.73 275.36 93.73",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.91 94.54 274.63 94.67 273.91 94.54 273.91 94.54",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.91 94.5 278.49 94.48 277.91 94.5 277.91 94.5",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.35 102.11 269.57 102.52 269.35 102.11 269.35 102.11",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.99 66.83 292.58 66.8 292.74 66.15 294.03 66.6 294.15 66.06 293.23 65.15 293.75 65.21 294.09 64.78 293.24 64.79 293.08 64.53 293.22 64.19 294 64.43 294.6 64.25 294.13 63.76 294.92 63.65 295.01 63.37 294.37 62.93 294.99 62.79 294.82 62.05 294.19 61.9 293.93 61.59 295.38 61.47 295.16 61.05 294.57 60.92 295.06 60.79 294.06 60.66 294.28 59.9 295.5 58.9 295.26 58.59 294.67 58.82 295.15 58.47 296.05 58.29 295.39 58.14 297.6 57.1 296.38 56.75 295.66 57.16 294.93 57.23 294.62 57.11 293.32 58.12 293.91 57.26 293.69 56.68 292.1 57.47 292.84 56.92 290.17 57.17 294.19 56.19 288.56 55.48 287.96 55.85 285.29 55.97 285.64 56.33 285.01 56.56 285.91 57.18 283.72 56.58 284.15 57.13 283.66 57.17 283.01 56.79 282.98 57.3 282.69 57.59 282.5 56.77 279.98 57.51 280.08 58.12 279.41 58.02 277.82 59.07 278.68 59.19 278.39 59.94 275.95 60.84 276.16 61.14 278.24 61.58 276.44 61.9 277.07 62.07 277.08 62.39 277.5 62.64 279.31 62.42 281.01 63.13 282.25 65.14 282.07 65.65 282.24 66.19 282.77 65.91 282.9 66.31 283.57 66.66 283.43 66.83 282.49 66.78 283.44 67.25 283.75 67.66 283.68 68.22 283.23 68.26 282.66 69.16 283 69.5 282.73 69.87 283.22 70.44 283.28 71.13 284.11 72.56 286.28 73.88 286.54 73.56 286.69 72.28 287.28 71.48 287.29 71.19 287.43 71 287.36 70.7 287.41 70.54 288.24 69.82 288.41 69.81 288.49 70.02 289.15 69.84 290.37 68.53 293.86 67.04 293.99 66.83 293.99 66.83",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.32 67.6 283.04 67.31 282.35 67.19 282.3 67.54 282.69 67.79 283.32 67.6 283.32 67.6",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.1 63.81 270.08 64.12 270.33 63.99 273.2 64.02 273.51 63.37 269.97 63.18 270.08 62.8 268.4 62.28 267.52 62.45 269.09 63.19 269.1 63.81 269.1 63.81",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.44 73.21 273.49 72.76 273.44 73.21 273.44 73.21",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.55 67.92 266.04 67.88 264.87 67.06 264.63 65.02 263.95 65.22 264.39 65.64 263.91 65.44 263.54 65.45 263.77 66.42 263.55 66.64 263.29 65.96 262.64 65.69 262.91 66.02 262.5 66.07 261.84 65.68 261.61 66.06 261.35 65.95 261.41 65.48 259.9 66.19 259.8 66.47 260.1 67 260.92 66.85 260.01 67.29 262.21 67.66 260.3 68.06 262.34 68.96 263.89 68.39 265.7 68.55 265.47 68.2 265.2 68.19 265.55 67.92 265.55 67.92",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.08 72.86 272.67 72.39 272.08 72.86 272.08 72.86",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.97 78.98 281.8 78.85 280.77 80.9 282.14 80.85 282.05 81.14 282.35 80.99 283.01 81.14 282.83 80.57 282.69 80.48 282.71 80.08 282.12 79.94 281.96 79.71 281.69 79.73 281.72 79.44 281.97 78.98 281.97 78.98",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.89 79.82 279.86 80.17 278.89 79.82 278.89 79.82",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.2 71.84 271.6 70.6 271.21 70.88 270.82 71.98 271.26 71.95 271.44 72.27 272.03 71.88 273.2 71.84 273.2 71.84",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.08 63.91 264.76 63.72 265.08 63.91 265.08 63.91",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275 69.36 275.05 68.82 274.6 68.71 274.28 69.34 275 69.36 275 69.36",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.58 66.74 267.2 66.53 267.66 65.53 267.45 65.49 267.4 65.65 266.97 65.47 267.42 65.03 267.17 64.66 265.92 65.22 266.3 65.56 265.61 65.51 266.58 66.74 266.58 66.74",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.33 67.32 260.95 65.34 260.52 64.91 258.9 64.55 257.81 64.78 257.97 65.15 257.41 66.37 258.33 67.32 258.33 67.32",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.89 61.68 269.55 62 269.89 61.68 269.89 61.68",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 63.72 260.23 63.3 259.69 63.72 259.69 63.72",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.87 78.25 255.4 79.11 255.23 78.5 254.87 78.25 254.87 78.25",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.73 61.58 267.71 61.83 268.73 61.58 268.73 61.58",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.4 66.44 275.87 66.47 274.28 65.52 273.89 65.87 273.68 65.79 273.1 66.02 273.12 65.34 272.87 64.87 272.19 64.89 271.44 65.25 271.55 65.84 271.37 66.22 271.74 66.51 271.15 66.26 271.07 65.75 271.26 65.17 271.61 64.8 270.23 65.24 269.91 66.64 270.65 66.78 270.57 66.96 270.05 67.03 272.56 67.72 272.92 67.53 273.71 67.63 273.66 67.38 273.74 67.18 274.88 68.06 274.53 68.41 275.08 68.21 275.93 68.97 275.93 69.67 276.51 69.6 277.05 69.89 276.54 70.19 275.65 69.84 275.56 70.52 274.27 70.86 274.07 71.37 275.71 71.25 276.12 71.65 276.32 72.16 278.25 72.89 277.33 71.85 278.81 71.98 277.69 70.39 277.79 69.94 278.29 70.12 278.8 70.68 279.53 70.31 279.99 69.78 277.57 68.19 278.05 68.05 277.65 67.83 277.85 67.64 277.66 67.31 277.41 67.46 277.47 67.14 276.68 66.77 276.23 66.89 276.1 66.77 276.4 66.44 276.4 66.44",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.06 64.78 273.27 65.27 273.8 65.45 274.64 65.26 273.75 64.79 273.06 64.78 273.06 64.78",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.89 61.66 262.68 61.51 261.8 61.86 262.26 62.2 262.89 61.66 262.89 61.66",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.71 60.71 265.17 60.95 264.62 61.07 266.64 61.43 266.5 60.99 265.71 60.45 264.48 60.29 264.71 60.71 264.71 60.71",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.61 61.8 261.15 61.7 261.61 61.8 261.61 61.8",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.82 62.2 264.29 61.74 264.82 62.2 264.82 62.2",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.81 63.1 260.86 63.37 260.56 63.71 260.92 63.7 260.3 63.95 261.23 64.01 261.5 63.88 262.17 63.91 261.66 64.25 261.64 64.62 264.15 64.01 264.28 63.18 263.89 63.36 263.25 62.58 262.88 63.03 262.91 63.3 263.17 63.59 261.18 62.84 260.81 63.1 260.81 63.1",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.54 63.49 259.06 63.23 259.3 63.54 260.03 62.66 260.13 63.02 260.73 62.75 260.73 62.45 260.95 62.23 260.67 62.06 260.46 62.22 260 62.19 258.41 63.27 258.54 63.49 258.54 63.49",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.13 61.35 263.14 61.17 262.38 60.99 261.72 61.33 262.13 61.35 262.13 61.35",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.66 59.76 268 60.18 269.02 60.18 268.4 60.54 269.72 61.19 270.22 61.15 270.93 60.34 271.52 60.09 270.84 59.67 270.68 59.3 268.4 58.34 268.44 58.52 267.91 58.9 267.97 59.34 267.66 59.76 267.66 59.76",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.48 61.53 268.1 61.38 268.13 61.08 267.03 60.69 267.48 61.53 267.48 61.53",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.83 59.81 266.36 59.63 266.83 59.81 266.83 59.81",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.39 63.51 267.51 63.94 268.56 64.19 268.39 63.51 268.39 63.51",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.18 62.46 266.29 62.92 265.88 62.81 265.76 63.1 265.55 63.13 264.97 62.54 264.93 63.04 265.48 63.47 266.32 63.42 266.24 63.92 266.97 63.94 267.26 63.6 267.23 63.2 266.83 62.6 266.18 62.46 266.18 62.46",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.54 57.93 269.74 57.98 269.88 58.13 269.77 58.41 270.09 58.64 270.98 58.65 271.08 58.84 273.57 58.38 273.57 58.72 272.42 59.05 272.86 59.57 271.16 59.14 271.18 59.78 272.51 60.7 271.57 60.52 270.67 61.01 271.5 61.01 271.43 61.26 271.83 61.78 271.37 61.74 270.76 61.4 270.7 62.05 269.99 62.48 273.94 62.44 274.1 62.08 272.95 61.96 272.96 61.72 273.88 61.66 273.94 61.26 274.6 61.19 275.3 60.34 274.36 60.14 275.15 59.88 275.59 59.49 276.27 59.52 278.85 57.84 277.8 57.81 279.7 57.17 279.8 56.77 278.85 56.43 278.05 56.58 278.19 56.33 271.41 57.12 270.84 57.56 270.3 57.49 270.02 57.75 269.27 57.85 269.54 57.93 269.54 57.93",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.8 78.34 244.26 78.06 243.8 78.34 243.8 78.34",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.85 76 247.54 76.41 247.29 76.53 247.44 76.83 247.62 76.83 248.07 76.44 247.94 76.21 248.19 76.07 248.12 75.88 247.85 76 247.85 76",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.27 74.97 242.96 75.1 243.44 75.25 243.51 74.98 243.27 74.97 243.27 74.97",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.13 84.29 302.82 84.42 303.13 84.29 303.13 84.29",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.21 86.14 310.42 86.07 310.2 86.18 310.73 86.32 311.21 86.14 311.21 86.14",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.91 86.23 314.11 85.97 314.1 85.89 313.59 86.08 313.42 86.37 313.91 86.23 313.91 86.23",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.48 70.84 297.04 70.26 296.59 69.49 296.35 69.52 296.01 69.34 295.97 69.59 295.41 69.66 295.23 69.6 294.99 69.79 294.85 69.71 294.68 69.84 294.64 70.03 294.4 70.16 294.31 69.83 293.77 69.44 293.82 69.67 293.69 69.66 293.46 69.77 293.28 70.04 294.05 70.12 293.98 70.32 293.39 70.57 293.91 70.57 294.14 70.85 293.84 71.18 294.29 71.15 294.94 71.42 296.48 70.84 296.48 70.84",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.57 78.37 299.62 77.95 299.62 76.94 299.89 76.74 299.69 76.29 298.84 76.47 299.01 76.66 298.72 76.83 298.34 76.85 298.55 77.44 298.45 77.78 298.21 78.06 298.57 78.37 298.57 78.37",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.64 74.4 299.41 74.77 299.64 74.4 299.64 74.4",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.56 74.95 299.81 75.18 299.68 75.48 299.87 75.7 299.58 75.96 299.83 75.85 299.98 76.09 300.18 75.77 300.21 76.05 300.08 76.46 300.6 76.39 300.84 76.91 300.81 77.28 300.45 77.3 300.34 77.37 300.23 77.63 300.44 77.78 300.1 78.06 300.24 78.23 300.82 78.33 300.85 78.43 300.46 78.5 300 79.15 300.27 78.97 300.53 79.03 300.69 78.84 301.23 78.7 301.51 78.77 302.41 78.42 302.26 78.34 302.29 78.1 302.58 77.7 302.03 77.48 302.03 77.26 301.17 75.87 300.84 75.82 301.25 74.83 300.58 74.82 300.46 74.69 300.73 74.34 300.79 74.1 300.63 74.27 300.24 74.29 299.77 75.03 299.56 74.95 299.56 74.95",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.13 76.43 306.39 76.09 306.48 75.65 306.36 75.75 306.24 75.65 306 75.78 306.14 76.14 306.04 76.26 306.13 76.43 306.13 76.43",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.61 74.48 308.37 75.02 308.61 74.48 308.61 74.48",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.04 73.79 309.81 73.82 310.04 73.79 310.04 73.79",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.74 74.33 310.11 74.04 309.88 73.97 309.74 74.33 309.74 74.33",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.44 58.3 309.75 58.3 309 58.61 310.27 58.86 311.64 58.01 310.39 57.84 310.19 57.96 309.99 57.7 309.92 58.1 309.64 57.93 309.34 57.92 308.95 57.68 308.97 57.86 308.71 57.79 308.72 58.02 308.45 57.81 308.3 57.97 308.48 58.14 308.44 58.3 308.44 58.3",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.95 59.69 306.2 59.88 305.73 59.34 305.95 59.69 305.95 59.69",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.28 58.95 306.07 59.35 306.43 59.79 306.94 59.81 307.32 59.3 307.35 59.55 307.66 59.5 307.8 59.63 306.81 60.1 307.13 60.24 307.85 60.18 306.86 60.54 307.22 60.85 307.57 60.88 307.4 61.04 307.69 61.23 307.93 61.14 308.77 59.54 309.21 59.38 309.28 59.47 309.33 59.78 309.46 59.92 309.4 60.31 309.74 60.38 309.94 60.58 310.7 60.08 310.15 59.94 310.09 59.78 309.81 59.67 309.61 59.45 309.54 59.22 308.62 58.9 308.48 58.59 308.19 58.74 308.28 58.45 307.91 58.31 307.72 58.13 307.58 58.52 307.8 59.13 307.16 58.43 307.02 58.76 306.92 58.84 306.65 58.6 306.95 58.46 306.75 58.39 306.19 58.44 305.9 58.59 305.9 59 306.28 58.95 306.28 58.95",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.08 81.31 352.77 81.46 352.56 81.95 352.56 82.27 352.95 82.13 352.73 81.83 353.6 81.92 354.37 81.52 354.98 80.79 354.26 81.02 353.45 80.38 353.21 80.51 353.08 81.31 353.08 81.31",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.87 86.27 348.71 86.56 348.92 86.44 349.12 87.35 349.53 86.64 349.45 86.38 349.2 86.17 348.87 86.27 348.87 86.27",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.28 84.67 351.05 85.09 349.83 85.3 349.26 85.79 349.26 86.04 350.59 85.64 350.75 86 351.18 85.97 351.31 85.68 351.43 85.62 352.17 85.59 352.39 85.34 352.74 85.27 352.93 84.04 353.27 83.58 353.09 82.48 352.62 82.64 352.37 83.75 351.8 84.46 351.56 84.33 351.28 84.67 351.28 84.67",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.01 86.44 350.33 86.29 350.58 85.92 350.21 85.88 349.86 86 349.81 86.55 350.01 86.44 350.01 86.44",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.36 91.42 345.82 90.13 345.16 90.72 345.36 91.42 345.36 91.42",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.54 92.98 341.73 92.48 341.28 92.46 340.92 93.03 341.54 92.98 341.54 92.98",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.13 96.86 346.7 97.27 346.38 97.19 345.95 97.48 345.81 97.91 346.41 97.59 346.71 98.3 347.1 98.51 347.08 97.98 347.48 97.79 347.39 96.88 347.13 96.86 347.13 96.86",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.02 93.98 345.22 94.86 346.38 95.45 346.82 96.51 347.11 96.15 347.01 95.65 346.34 94.97 345.83 94.88 345.64 94.5 345.89 93.91 345.81 93.1 345.27 93.06 345.2 94.03 345.02 93.98 345.02 93.98",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.23 95.22 345.58 95.65 345.23 95.22 345.23 95.22",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.55 96.65 344.08 97.34 344.75 96.64 344.85 96.19 344.55 96.65 344.55 96.65",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 96.66 346.5 96.86 346.77 96.66 346.77 96.66",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.38 96.31 345.82 95.83 345.84 96.39 346.04 96.27 346.12 97.05 346.52 96.38 346.38 96.31 346.38 96.31",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.88 102.66 356.43 102.97 355.64 103.02 356.24 103.31 357.01 102.87 357.12 102.5 356.88 102.66 356.88 102.66",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.37 102.61 357.25 102.19 357.14 102.22 357.37 102.61 357.37 102.61",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.34 103.23 351.6 101.36 350.67 102.14 350.28 101.12 349.43 101.01 349.12 101.28 349.31 101.39 349.52 101.67 350.11 101.69 350.08 101.82 349.54 101.95 349.77 102.31 351.77 103 351.98 103.47 351.97 103.84 351.62 104.18 352.48 104.11 353.27 104.59 353.94 103.99 354.71 104.17 355.53 104.97 356.31 105.11 356.25 104.86 355.61 104.39 355.26 103.5 355.34 103.23 355.34 103.23",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.83 97.06 330.68 97.99 330.87 98.6 331.43 98 330.83 97.06 330.83 97.06",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.41 106.21 319.28 106.34 319.23 106.63 318.83 107 318.82 107.22 317.59 107.88 317.26 110.98 317.5 111.75 318.14 111.92 318.51 111.76 319.59 107.71 319.81 107.66 319.41 106.21 319.41 106.21",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.98 96.07 321.35 95.98 320.98 96.07 320.98 96.07",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.85 118.94 354.22 118.75 354.39 119.58 354.88 120.21 355.09 120.05 355.17 119.83 355.39 119.88 355.48 118.79 354.85 118.94 354.85 118.94",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.81 105.73 349.29 105.6 348.81 105.73 348.81 105.73",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.13 116.44 351.58 116.37 351.13 116.44 351.13 116.44",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.53 112.67 357.42 111.67 356.61 110.77 356.48 110.34 356.33 110.21 356.12 110.23 355.76 109.34 354.91 108.79 354.21 106.75 353.92 106.76 353.45 105.19 353.21 105.49 352.93 107.66 352.61 108.15 350.85 107.01 350.91 106.46 351.15 106.26 351.27 105.98 351.19 105.78 351.05 105.95 350.91 105.73 350.63 105.87 349.57 105.4 349.71 105.67 349.14 105.87 348.62 106.68 348.64 107.03 348.21 107.1 347.57 106.57 347.36 106.71 347.25 106.9 346.96 106.92 346.9 107.1 346.72 107.24 346.65 107.65 346.38 107.62 346.44 107.93 346.32 108.15 346.18 107.84 345.89 108.01 345.87 108.49 345.34 109.09 343.09 110.03 342.89 110.33 342.85 110.08 342.66 110.38 342.61 111.51 342.82 112.06 342.6 111.85 342.71 112.14 342.45 111.92 343.46 114.56 343.38 115.11 343.17 115.46 343.27 115.73 343.54 115.99 344.25 116.06 349.16 114.36 350.26 114.78 350.28 115.03 350.61 115.38 350.7 115.84 351.69 115.02 351.3 115.94 351.64 115.9 351.85 115.78 351.8 116.23 352.07 116.21 352.58 117.31 353.71 117.77 354.18 117.46 354.33 117.53 354.4 117.65 354.5 117.57 354.87 117.92 355.39 117.39 356.16 117.23 357.53 112.67 357.53 112.67",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.84 121.95 362.98 121.76 362.84 121.95 362.84 121.95",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.28 66.97 319.96 66.8 319.63 66.54 319.28 66.97 319.28 66.97",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.73 64.92 320.79 65.22 320.93 65.08 321.68 65.58 322.63 65.55 322.13 65.07 322 64.19 323.03 62.58 326.82 60.48 322.33 61.94 321.94 62.76 321.63 62.95 321.49 63.48 320.91 63.88 321.03 64.16 320.36 64.69 320.73 64.92 320.73 64.92",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.03 56.29 334.54 56.38 335.03 56.29 335.03 56.29",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.91 62.68 353.43 62.18 352.82 62.52 353.91 62.68 353.91 62.68",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.04 61.9 352.69 62.07 353.04 61.9 353.04 61.9",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.88 57.47 335.63 57.84 337.3 58.4 337.72 57.62 336.9 57.19 335.88 57.47 335.88 57.47",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.56 59.13 339.8 58.47 339.32 58.13 338.79 58.27 338.83 58.05 338.62 57.79 338.23 57.96 338.1 58.3 337.82 58.54 337.56 59.13 337.56 59.13",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.92 61.45 353.47 61.3 353.44 60.82 354.12 61.26 354.38 60.89 354.29 60.54 353.49 60.39 352.96 60.56 352.25 60.2 351.62 61.19 351.92 61.45 351.92 61.45",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.78 75.96 353.54 75.47 353.31 79.94 353.55 79.66 353.87 79.96 353.55 79.11 353.66 78.44 354.1 78.38 354.22 78.3 353.78 75.96 353.78 75.96",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.26 62.03 342.04 62.23 342.7 62.09 342.26 62.03 342.26 62.03",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.85 61.38 356.74 61.16 355.2 60.78 354.94 61.07 355.85 61.38 355.85 61.38",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.31 57.15 335.22 57.31 334.96 57.46 335.29 57.7 336.73 57.02 336.83 56.67 336.4 56.06 335.46 56.58 335.3 56.87 335.31 57.15 335.31 57.15",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.65,67.88l.42.09-.08-.12.08,0,.2,0,.24-.35-1.24-.63h-.49L370,67l-.05.27-.24-.11,0-.42-.14-.22-5.35-1.76-.12.27.18.33-.09.4-.88-.45.45-.24-.47-.2-.44.4-2.06,0-.07.39-.1-.4-.49-.18.07-.27-.61-.57-2.27.13-.1-.2-1.08-.36,0-.13.3-.17-1.19-.18-.22.41-.4,0,.29-.21-.41-.13.2-.11H355L353,63l-.08.19-.67.41h.3l-.1.22.11.28h-.65l-.1.09v.17L351,64l-.43.17-.76-.23-.44.76-.23-.08-.89-.95.42,0-.24-.88-.25-.18h-.63l-.75-.38-.36.43v.31L344.57,63l.15-.2h-1.94l0,.22-.06-.4-.19-.05-.38.08-.42-.23-.42.28.22.06-1.61.62.09-.29,2-1.17.18-.23.44-.21.17-.25-.16-.14.18-.08-.12-.38-.24,0-.08-.34-1.53-.09-.24.16-.46.07.26-.4-1-.08.45-.21,0-.16-.69-.18-.49.13-.65.73.07.17-.77.19.24.19-1.07.13.1-.23-.35.11-.24,0-.59.19.22.16-2.18.68-.05.1-.14.11.1.14h-.31l.36.25-.28,0,.28.26,0,.18-2.11.27-.11.71.49.28.21.39-1.72-.56-.23.21.35.19-.7.17.82.61-.06.12-.42-.23-.62,0,.07-.68-.16-.5-.19.6-.43.27-.15.25.42.56-.2,1.11.28,0,.42-.11.7.24.14.32-.17.3.42.31-.41,0-.16-.25.09-.3-.42-.42-.56.19.08.56-.91,1.12-1,0-.18-.17.61.11.83-.84.17-.62-.29-.35.08-1.24-.3-.45.28-1-1.15-.17-1.08,1.62.2.05-.18.81.43.17.15.33.22.12-.22.41-3.56-1.45.11.34.5.29.16.33-.11.23-.44.24V67l-.22-.18-.55.33-.61,0-.34.28-.49,0,.26-.52-.5.18-.07.23-.16-.1-1.57.7-.08.44-.62.11-.28-.3,0-.26.58-.15-.22-.38-.91-.18.17.44-.14.46.25.5-.11.32h-.16l-.1-.11-.37-.07-.89.59.17.68-.81-.11-.41-.26-.22.23.11.24.35.12,0,.25-.27.06-.61-.29-.28-.53,0-.52-1-.85,2.26.68,1.05-.56,0-.48-3.16-1.34.27-.1-.24-.11-.47.06,0,0h-.43l-.23-.2h.18l.49-.2-.19-.2-.46-.19-.37.26,0-.23-.15-.22-.44.56V65.7l-.57.55.06-.26.23-.33,0-.15-.2.19-.25,0-.07.16-.32.16-.13.4-.13-.26.27-.38-.42.12,0,.27-.1.09h-.27l.2.2-.17,0-.19-.13-.12.09.08.26-.12-.08H309l0-.24-.25,0-.1.12,0,.19-.12.1-.37.06-.18.29.22,0,.05.15,0,.1-.19,0-.15-.1-.2.12.08-.34-1,.91h.12l1.05-.38,0,.22-.1.07-.14-.08-.78,1.13-.06.3-.28.06-.05.66-.47.14.2.24-.43.22-.39.57-.2-.17,0,.23-.54.3.19.16h-.31L304,72l-.14,0-.16.19.14.2-.11.74.19.06.25-.11.07.12-.19.18-.14,0-.12.12,0,.24h.39L304,74l.38.33.42.11.66-.58.25-.06.09-.3.88,2.46.28,0,.24-.38.3,0,.21-.19.12.06L308,75l-.13,0,.05-.86.74-.94-.34-.42-.25-.07-.05-.46.65-1.23.89-.72,0-.4.13-.33.24-.22.57-.05.29.13.13.31-1.44,1.58v1.4l.95.36,1.44-.38.17-.25-.17.25.15-.06.23.26.31.07-2.12.52-.22.24.08.25.21.14.07.16h0l0,.4-.3.16-.32-.41-.34.19-.2.72v0l0,.56.06.06-.12.22-.41,0,0,.1-.2.12-.17-.25-1.44.6,0,0-.22-.12,0-.24-.73.38-.57-.36-.17-.3.44,0-.13-.25-.16,0,.1-.26.23-.14-.17-.19,0-.63-.48.3,0,.18L305,75l-.18.3.35,1.53-.15.16-.54,0v.08l-.45.07-.14.28-.17,0-.17.1-.45.72-.37.17-.82,1-.45-.17-.21.17.05.43H301l-.22-.12-.35,0-.22.2,0,.25.79.25.49.84-.22,1.23-2.25-.16-.3.22,0,3h.75l.43.46L300,86l1-.19.93-1v-.6l1-.85.15-.34,0-.11.3-.41.65.15,1.06-.65,2.47,2.28,0,.76.39-.59-.16-.31.34-.19.27,0-2-2v-.41l.16-.24.23,0,.12.29.28.13.32.56,1.2.79.07-.2-.07.2.09.85.24.34h0l.2.35.57.21-.38,0,.26.62.34.17L310,85.2l.25,0-.16-.15.13-.09.26,0-.12-.33-.3,0,.12-.22-.29-.45.18-.12.29,0,.07-.31.22.08.27-.16.45.23.34-.24.48-.06-.27-.25-.21-.61.36-.44v-.22l.37-.56v0l.48-.73.4-.08,0,.27.59.08-.48.31.36.18,0,.31,1.12-.35-.37-.1-.29-.32,1.57-.63-.44.31.13.22-.5.52,1.61,1.21.13.42-.08.14-1.3.3-1.28-.45-1.89.48-.18.32-.75.09-.08.3.15.11,0,.81.42.36.18.06.22.25.76-.26.49.31.37-.08.34-.25.28.07.27-.09L314.34,87l.19.09h0l0,.24,0-.24-.19-.08L314,88l-3.19-.23v0l-1-.44-.8.48.05.53-1.22-.24-.59-.51-1.06-.22-.57-.44.28-.29.08-.9-.05-.15-3.4.22-1.25.77-1.35-.32-.4.83-.54.31-.47.74v.62l-2.6,4,.28,1.11-.26,1.48L296,96l0,.24,0,.19,3.09,3.26,1.83-.23.27.1,1.86-.81h0l.54.14.53.76.9-.17.15.22.27.06.1.4-.07.36h0l-.09.54-.06.08.14.21-.34.43,1.58,3-.06.43.23.85-.75,2.53L308.4,116l.34.27,2.41-.55,2.11-2.4.19-.88-.14-.16,1-.8-.14-1.93,2.12-2.14-.67-3.56,4.5-7.42-.23-.14-2.46.49-.19-.23-.05.07.05-.07-.19-.08.21-.2-3.91-7.81.61,1,.22-.58,3.12,7,2.92-1.09.35-.42,1-.32.14-.32.4-.09.24-.38.23-.13.12-.56.6-.72,0-.22-.31-.43-.6-.24-.3-.94-.43.56-1.12.52-.07,0-.15-.26,0-.64-.24.4h0l-.94-2,0-.07.67-.18.57,1,1.27.58.58-.2.28.53,3.48.22.24.5.71.53h.4l-.5.21.77.69.5-.65,1.72,6,.68-.65.56-2.64,2.07-1.92.11-.43,1.5-.72,1,2-.05.66.15.22.36,0,.31-.42.19.16,1.49,5.69,1.06.76L339,99l-1.54-2,.25-1.5.31-.11.69.48.1.37.23,0v.22l.29,0,.2.2-.1.36.18.16.52-.67.73-.33.28-.55-.08-1-1.2-2.06.72-.86.64-.07.18.53.1-.18,1.23-.85,1-.12,1.24-1.22V89.4l.26-.14.7-1.3-.5-.21.39-.22-.55-.48.53,0L345.15,86l-.32-.25.35-.61.84-.45-.21-.26-.36-.15-.49.37-.23-.33-.38-.13v-.52l1.52-.8-.31.89h.26l.68-.45.18,0,.42.23-.22.45.07.25.18.1.29-.07.08,0,.12.22-.11,1.33,1.07-.45.15-.18-.48-1.28-.33-.34.11-.37.64-.46.13-.5.51-.53h0l.3-.2.43.26,2.39-2.81.68-2.79-.65-.64-.32,0-.23.31-.21,0,0-.41-.23.3-.05-.42H351l0-.31,3-2.65,2.53-.2.54.2-.19.27,1.41-.28-.15-.13,0-.35,1-1.12.62-.08.24.11.27-.13-.18.39.21.16-.1.17,1.07-.57.08-.41.64-.27v.1l-2.65,2.9-.35.09-.47,1.47.42,2.53.58-.63.08-.43.25-.19.28-.07,0-.35.35-.39.45-.1-.07-.41.27-.51.29,0-.18-.27.07-.69-.24,0-.05-.43.6-.91.33,0,.14.07.37-.41.08.36.35-.23.93-.1.28.25.15-.25L366.7,70l.74,0v-.33l-.81-1.06-.31-.07.37-.13.2.2.42,0,.5-.3.11-.22-.07-.24,0-.21.14-.14h.2l0,.22.13.28,1,.2.26.35.57.24.44,0-.17-.23.18,0v-.62l.11-.05Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.89 63.46 327.49 63.29 327.33 63.62 327.89 63.46 327.89 63.46",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.76 63.56 330.48 63.7 330.76 63.56 330.76 63.56",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.08 91.65 273.95 91.77 274.21 92.2 274.08 91.65 274.08 91.65",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.82 97.86 280.09 97.81 280.07 97.58 279.81 97.67 279.82 97.86 279.82 97.86",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.7 102.11 340.51 102.21 340.7 102.11 340.7 102.11",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3 104.38 346.42 104.25 344.95 104.46 345.55 104.57 346.3 104.38 346.3 104.38",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.11 104.27 343.77 104.32 343.6 104.55 344.13 104.63 344.65 104.45 344.11 104.27 344.11 104.27",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.86 104.82 346.95 104.71 347.76 104.27 347.21 104.29 346.57 104.65 346.4 105.12 346.86 104.82 346.86 104.82",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.03 102.14 349.01 102.39 348.75 101.97 348.03 102.14 348.03 102.14",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 105.05 344.65 104.86 344.98 105.03 345.33 105.05 345.33 105.05",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.28 102.17 347.73 102.3 347.28 102.17 347.28 102.17",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.6 101.92 344.98 103.24 345.16 102.83 345.12 102.08 345.36 102.24 345.55 102.66 345.88 102.7 345.71 101.56 346.27 101.1 345.51 101.36 345.06 100.97 346.92 100.2 346.53 100.38 345.6 100.28 345.15 100.5 344.6 101.92 344.6 101.92",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.09 100.21 347.84 100.06 348.03 100.96 348.31 100.32 348.09 100.21 348.09 100.21",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.62 100.39 336.85 100.71 336.62 100.39 336.62 100.39",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.15 101.43 337.32 101.65 337.15 101.43 337.15 101.43",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.94 104.42 343.38 104.43 343.01 104.18 342.37 104.08 342.74 103.79 339.9 103.49 339.72 103.73 340 103.79 340.19 104.02 342.94 104.42 342.94 104.42",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.91 100.64 341.77 102.16 342.06 102.31 342.55 102.24 343.02 102.48 343.55 102.37 344.05 100.81 344.61 100.45 344.14 99.13 344.76 98.67 344.51 98.44 344.18 98.34 343.85 98.03 343.28 98.85 343.09 98.95 342.83 98.91 342.51 99.49 341.97 99.68 341.73 100.21 341.15 100.06 340.91 100.64 340.91 100.64",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.85 102.73 339.91 102.3 340.06 102.2 340.07 101.95 339.77 101.62 339.72 101.81 339.87 102 339.64 101.93 335.99 98.68 339.33 103.34 339.72 103.34 339.85 102.73 339.85 102.73",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.18 84.94 306.74 84.95 306.44 85.13 307.22 85.62 307.46 84.96 307.18 84.94 307.18 84.94",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.86 83.7 305.14 84.61 305.39 84.43 305.45 83.77 305.12 83.63 304.86 83.7 304.86 83.7",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.33,78.9a4.3,4.3,0,0,1-4.05,4.36,4,4,0,0,1-4-4.15,4.29,4.29,0,0,1,4-4.36A4,4,0,0,1,265.33,78.9Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,96.37a2,2,0,0,1-1.88,2,1.87,1.87,0,0,1-1.87-1.93,2,2,0,0,1,1.87-2A1.88,1.88,0,0,1,271.62,96.37Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.31,95.07a7.19,7.19,0,0,1-6.91,7.27,6.84,6.84,0,0,1-6.87-7,7.19,7.19,0,0,1,6.87-7.27A6.85,6.85,0,0,1,317.31,95.07Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,68.42a3.12,3.12,0,0,1-3,3.14,2.9,2.9,0,0,1-3-3,3.13,3.13,0,0,1,3-3.14A2.91,2.91,0,0,1,330.86,68.42Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1,86.13a3.55,3.55,0,0,1-3.41,3.58,3.36,3.36,0,0,1-3.4-3.42,3.55,3.55,0,0,1,3.4-3.57A3.35,3.35,0,0,1,338.1,86.13Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,65.85a3.07,3.07,0,0,1-2.93,3.08,2.86,2.86,0,0,1-2.92-2.9A3.06,3.06,0,0,1,349.33,63,2.84,2.84,0,0,1,352.26,65.85Z",
    style: {
      fill: "#0D6EFD"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-135"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.1,
    cy: 470.73,
    rx: 26.55,
    ry: 8.24,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.1,
    cy: 470.73,
    rx: 26.55,
    ry: 8.24,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,427.07A34.22,34.22,0,0,0,313.91,445c0,15.27,9,27.66,20.07,27.66s20.07-12.39,20.07-27.66a34.31,34.31,0,0,0-4.8-17.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,427.77c.14,2.47-6.67,4.5-15.21,4.53s-15.57-1.95-15.71-4.42,6.66-4.49,15.2-4.52S349.38,425.3,349.52,427.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.29,429.59c-2.56-1.51-7.94-2.55-14.13-2.52s-11.66,1.13-14,2.71c2.56,1.51,7.95,2.54,14.13,2.52S346,431.16,348.29,429.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.74,296s1.86,3.53.2,6.84-3.72,6.63-2.48,8.29,5,3.73,4.56,7.25-5.39,10.57-2.28,14.51,8.29,3.73,8.49,8.08-5,7.87-3.52,11.81,10,4.77,10,7.46-3.32,5.59-.62,8.5,15.72,10.46,17.59,7.36,5.61-11.72,3.15-23.92c-.42-2.05-3.34-2.51-3.75-5.41s.83-8.08-1.25-11-8.7-3.94-9.11-6.22,2.48-7.87-.42-11.4-9.74-5.18-9.74-7.45,2.08-5.19-.83-8.29S296.74,296,296.74,296Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,320.43c4.32,13,11.87,30.67,14.94,39.2,3.73,10.36,7,17.86,8.63,28.22.77,4.82,1.38,22.39,1.81,39.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.77,297.26s3.53,2.9,6.63,15.54c.21.81.44,1.67.69,2.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.51,319.62a6.55,6.55,0,0,0-.17,5.47c1.33,2.66,3,5.31,2,6.64s-4,3-3.64,5.8,4.31,8.46,1.82,11.61-6.63,3-6.8,6.47,4,6.3,2.82,9.45-8,3.81-8,6,2.65,4.48.5,6.8-12.59,8.38-14.08,5.89-4.49-9.37-2.52-19.14c.33-1.64,2.67-2,3-4.33s-.66-6.47,1-8.79,7-3.15,7.29-5-2-6.31.33-9.12,7.8-4.15,7.8-6-1.66-4.15.66-6.64S361.51,319.62,361.51,319.62Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,339.16c-3.45,10.43-9.5,24.55-12,31.37-3,8.29-5.58,14.3-6.91,22.59-.66,4.14-1.17,20.1-1.52,35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,320.62s-2.82,2.32-5.3,12.43c-.17.66-.35,1.34-.56,2.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,366.58a5.46,5.46,0,0,1,.13,4.57c-1.1,2.22-2.49,4.43-1.66,5.54s3.33,2.49,3.05,4.85-3.6,7.07-1.52,9.7,5.54,2.49,5.68,5.4-3.33,5.27-2.36,7.9,6.65,3.19,6.65,5-2.22,3.74-.41,5.68,10.51,7,11.76,4.92,3.75-7.83,2.1-16c-.27-1.37-2.23-1.68-2.5-3.62s.55-5.4-.83-7.34-5.82-2.63-6.1-4.16,1.66-5.26-.28-7.62-6.51-3.46-6.51-5,1.39-3.46-.55-5.54S304.49,366.58,304.49,366.58Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,382.9c2.89,8.71,7.94,20.51,10,26.21,2.5,6.93,4.66,11.94,5.77,18.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,367.41s2.35,1.94,4.43,10.39c.14.54.29,1.12.46,1.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.85,363.13a5.44,5.44,0,0,0-1.18,4.41c.57,2.42,1.41,4.89.35,5.78s-3.81,1.67-4.08,4,1.89,7.71-.73,9.79-6,1.16-6.77,4,2,5.89.49,8.23-7.21,1.58-7.62,3.33,1.3,4.15-.89,5.63-11.84,4.41-12.58,2.1-1.86-8.48,1.61-16.05c.59-1.27,2.55-1.12,3.27-2.95s.7-5.38,2.49-7,6.27-1.23,6.88-2.65-.41-5.5,2-7.35,7.13-1.88,7.48-3.37-.56-3.69,1.81-5.27S375.85,363.13,375.85,363.13Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,377.5c-4.8,7.82-12.42,18.15-15.73,23.23-4,6.17-8.82,10.12-9.93,17-.34,2.12-.63,6-.88,10.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,363.78s-2.74,1.35-6.7,9.1c-.25.5-.53,1-.84,1.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-135"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.71,
    cy: 478.73,
    rx: 41.29,
    ry: 12.27,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.71,
    cy: 478.73,
    rx: 41.29,
    ry: 12.27,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91,331.62s1.71,15.12,2.44,22.93,2.68,30,2.44,32.69-2.68,30.57-2.68,41.3,1.46,25.86,1.46,25.86-2.44,4.14-1.95,6.34a33.45,33.45,0,0,1,1,5.61,13.31,13.31,0,0,0,.49,2.93s3.66,2.44,5.86,2.68,6.58-1.22,6.58-1.95,1.95-8.05,1.95-10.74,0-1.7.74-5.36,8.53-54.23,9.51-58.87,2.44-39.51,2.44-39.51l1.71,3.17s4.14,37.32,3.9,41.47-1.71,20-1,27.32,2.2,25.37,2.2,27.32-.49,6.34-.49,8.05-1.46,4.39-.73,5.61a21.31,21.31,0,0,1,1.46,3.66s8.79,1.46,11.22,1.46,4.4-2.19,4.4-2.19v-4.15c0-2.2.48-4.15.48-6.34s.25-6.83.25-10.25a88.79,88.79,0,0,1,1-9.76c.25-2.19,3.66-27.8,4.15-37.32s2.68-31,2.68-34.39-.24-35.37-.24-35.37l-.49-5.86s-25.61,3.42-37.81,1.71-22.2-2.2-22.2-2.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48,466.13a5.13,5.13,0,0,1-2,1.08c-1.34.4-2.15.67-3.22-.81s-3.23-3.22-5-2.42-3.76,2-4.16,3-.14,10.75-.14,12.64,3.63,2.68,7.26,2.82a11.52,11.52,0,0,0,6.45-1.88s3.09.26,4.17-1.08.54-4.44-.14-5.51-1.2-2-2.15-3.9A11.48,11.48,0,0,1,138.48,466.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,479.44a3.29,3.29,0,0,0,.59-1.75c-1.77.81-3.86.3-4.62.41-.94.13-3.09,1.61-7.93,1.34a16.23,16.23,0,0,1-5.94-1.35c0,.66,0,1.18,0,1.49,0,1.88,3.63,2.68,7.26,2.82a11.52,11.52,0,0,0,6.45-1.88S140.76,480.78,141.84,479.44Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.13,
    y1: 480.52,
    x2: 137.67,
    y2: 474.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,467.4a2.76,2.76,0,0,1-1.11-1c-1.08-1.48-3.23-3.22-5-2.42a13,13,0,0,0-3.83,2.48c.58,1.66,2,4.59,4.77,4.78C131.48,471.4,133.24,469.41,134.35,467.4Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,469.2s-2,.54-3.09-.13-2.69-4.7-6.32-4.3-5.24,3.76-6,4.17-.94.53-1.21.94-.4,11.29-.27,12.37,7.8,2.14,12.51,1.61,6.31-2.56,6.72-2.83a3.83,3.83,0,0,0,2.42-3.22c.27-2.42-.54-5.11-1.89-6.05a20,20,0,0,1-2.41-2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,480.76a32.55,32.55,0,0,1-11.75-1.8c0,1.62,0,2.94,0,3.29.14,1.07,7.8,2.14,12.51,1.61s6.31-2.56,6.72-2.83a3.83,3.83,0,0,0,2.42-3.22,10.06,10.06,0,0,0,0-1.82c-.2.41-.43.85-.69,1.28C178.27,478.61,176.25,480.63,169.8,480.76Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.08,
    y1: 476.17,
    x2: 174.3,
    y2: 482.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,472.7c2.41.28,5-1.63,6.44-3.41a1.91,1.91,0,0,1-.53-.22c-1.08-.67-2.69-4.7-6.32-4.3s-5.24,3.76-6,4.17C159.58,468.94,162.54,472.3,166,472.7Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.16,
    y1: 355.53,
    x2: 146.3,
    y2: 352.6,
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,217.89s1.47-2.44,2,.73-.74,6.58-2.44,7.8-2.44,0-2.44-1.22S164.54,217.89,164.54,217.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,219.11a2,2,0,0,0-2.68,2.19c0,2.93,3.9,7.08,5.61,6.1S136,219.11,136,219.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,190.56s-3.81,6.34-7.8,8.05c-5.13,2.2-9.27,8.79-9,14.15s8.05,22.93,9.27,23.42,16.59-.73,17.08-1.46,2.68-8.05,4.63-15.13,1.95-10.73,1.95-10.73a22.46,22.46,0,0,0,1-7.07,12.86,12.86,0,0,0-3.17-7.81l-2.93,3.66,1-8.29a9.41,9.41,0,0,0-5.85,1.21,21.55,21.55,0,0,0-4.63,4.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.77,197.16c-.36-1.09-1.45-1.09-2.36-3.45s-3.45-1.81-4.18-2.18-.72-.72-.36-1.81,1.27-4.72-.36-4.72-2.91,3.81-3.27,4.72a48.72,48.72,0,0,1-3.27,4.72,12.77,12.77,0,0,1-2.36.36c-.9,0-2,1.82-2.17,2.72-.12.57.76,2.42,1.44,3.72a28.84,28.84,0,0,0,1.1,3.18s.9,1.27,3.63.91,7.8,3.27,8.53,2.72,2.36-3.81,3.08-5.62A9.34,9.34,0,0,0,235.77,197.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36,348.87s3.3,5,3.48,6.94.17,5.56.34,6.77-.52,2.09-1.38,2.09a1.83,1.83,0,0,1-1.39-.87,20.29,20.29,0,0,0,.52,2.95c.34,1.22,2.25,2.26,2.08,3.47s-2.08,1.74-4.69,1.74a7.89,7.89,0,0,1-7.29-5c-1.56-3.64-3.12-14.06-3.12-16S116.63,347.48,118.36,348.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72,355.29s.69,1.56-.7,4a16.08,16.08,0,0,0-2.08,4.69,16.72,16.72,0,0,0,1.56,3.47c.7,1.39,3,1.22,3.13,2.44a2.68,2.68,0,0,1-.35,1.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.91,362.72a18.07,18.07,0,0,0,.93,4c.7,1.74,4.34,2.78,3,4.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72,363.45a15.36,15.36,0,0,0,.87,3.3c.52,1,4,2.08,3.3,4.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.41,363.8s-.35-2.78-.52-3.82a23.28,23.28,0,0,1-.18-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.36,242.33a36.35,36.35,0,0,0-15.61-7.07c-9.76-1.95-22.69,1.22-27.81,4.63a13.42,13.42,0,0,0-5.61,9.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,212.57a5.54,5.54,0,0,1,0-2.92c.49-1,.73-3.91,1.46-4.64s6.1-3.66,10-1.95,5.86,9,6.59,10.73-1.46,5.61-2.44,6.1-1.95-2.93-2.93-3.9S220,211.11,216.61,212.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21,241.85c-1,.24-19.52,2.68-27.81,5.12s-15.12,5.61-15.37,8.78-7,62.26-7.26,65.68,2.2,23.17,3.42,23.9,6.83,1.22,8.78.49a8.37,8.37,0,0,0,3.17-2.19l.73-16.35s.49,5.61,1.46,5.86a109.49,109.49,0,0,0,37.33,3.17c21-1.71,29.76-4.88,31.46-6.1s1.47-4.88,1.47-4.88.24-2.68.24-5.37S182,263.31,182,263.31s32.2-8.78,34.64-11.71,14.15-34.88,14.15-37.32-5.37-6.1-9.27-6.34-13.42,19-15.61,20.49-23.18,9.76-31,11.22S152.21,241.85,152.21,241.85Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,258.38s3.3,13,13,18.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.76,282.45q1.1.57,2.25,1.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,271.86a57.46,57.46,0,0,0,10.73,8.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.23,273.2,182,263.31l-12,4.44,4.65,1.91c-2.27,2-5.24,4.82-3.4,4.49a31.73,31.73,0,0,0,6.94-3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,320.21c0-4.39,2.14-49.09,2.14-49.09l-.73-3.17-5.41-8.62L114.55,276c-2.29-.71-6.9-1.93-5.16.4a33.45,33.45,0,0,0,5.46,5.27l-1.64,33.06a14.14,14.14,0,0,0,1.94,7.88l1.68,2.86A12.51,12.51,0,0,1,115.67,320.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83,325.51a9.25,9.25,0,0,0,1,1.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.61,324.11c-37.32,16.83-70.74,3.17-70.74,3.17s.49,5.61,1.46,5.86a109.49,109.49,0,0,0,37.33,3.17c21-1.71,29.76-4.88,31.46-6.1s1.47-4.88,1.47-4.88,0-.56.1-1.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,342.89s5.61,2.44,10.25,1,5.85-2.93,6.58-2.68.74,6.09,0,7.8-2.44,2.93-7.56,3.42-7.8-2-8.29-3.42A48.78,48.78,0,0,1,102.5,342.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-135"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.32,
    cy: 465.55,
    rx: 36.29,
    ry: 11.26,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.32,
    cy: 465.55,
    rx: 36.29,
    ry: 11.26,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.05,209.94s3,3.56,2.85,5A7.87,7.87,0,0,0,92,219.56c.71.89,2.67,1.6,2.67,3.2a5.74,5.74,0,0,1-1.07,3s.72,7.13,0,8.91-3.56,1.78-5.16,1.78-2.49-.18-3-.18-3.74-2.85-6.23-9.08.36-15.5,2.49-16.74S88.05,209.94,88.05,209.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.81,
    y1: 220.81,
    x2: 94.11,
    y2: 216.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,216s3.92-1.07,2.5,4.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.25,241.89l-1.11,13.25-14.07-3.32V241.33S75,239.12,80.25,241.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,204a22,22,0,0,1-8,.55c-4.12-.55-13.18.55-15.65,6.6s.55,11.53.27,13.18-4.67,4.12-4.67,6.6,1.92,4.67,1.1,6.59-2.2,3.57-1.1,5.49,5.5-1.37,6,.55,4.67,4.4,6.6,4.4,4.12-4.12,5.22-2.48,3.29,3.3,5.49,3,3.29-5.35,8-3.3,6.21-2.24,6-6c-.16-3.58-4.39-8.52-3.57-11.27s2.47-4.67,1.92-7.69-3-4.12-1.65-6.32,3.3-2.19,3.85-4.94-.55-6.32-4.67-6.87S78.8,204,78.8,204Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,344.3s3.87,22.08,1.94,43.34c-.78,8.53-5,10.77-6.08,22.08s2.76,34.23.83,46.38c-.26,1.66-2.21,5.8,0,8s9.94.83,12.15.83,7.45-.83,8-2.21-3.31-2.76-5.79-7.45a38.49,38.49,0,0,1-4.42-17.39c0-6.35,3.86-24.29,6.9-38.92s4.69-22.64,4.69-30.92v-26c0-1.38-7.45-4.69-13.25-3.59S54,344.3,54,344.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07,455.27c-.43-.8-.83-1.66-1.21-2.55-.72,1.52-1,3.34-2.38,3.66-2.49.55-10.77-.28-10.77-.28-.27,1.66-2.21,5.8,0,8s9.94.83,12.15.83,7.45-.83,8-2.21S67.55,460,65.07,455.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,444.16a34.71,34.71,0,0,1-.61-6.28c0-6.35,3.86-24.29,6.9-38.92s4.69-22.64,4.69-30.92v-26c0-1.38-7.45-4.69-13.25-3.59s-5,5.8-5,5.8,3.87,22.08,1.94,43.34c-.78,8.53-5,10.77-6.08,22.08-.8,8.22,1,22.55,1.33,34.44A21,21,0,0,0,61.26,444.16Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.44,439a44.66,44.66,0,0,0,6.34.83,19.33,19.33,0,0,0,5.25-1.1l.83,7.18a35.44,35.44,0,0,1-7.73,1.38,10.24,10.24,0,0,1-4.14-.56S50.44,441.19,50.44,439Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,323.87s-1.66,11,0,16.56,6.07,13.26,7.18,15.46,2.48,9.11,2.48,10.49,1.1,17.67-.55,25.95-3.59,13-3.59,21,3.86,37.89,3.86,43.13-1.93,11.87-.55,13.25,25.12-1.43,27.33-2.26A2.94,2.94,0,0,0,88.53,463c-.83-1.1-10.77-4.36-12.42-5.74s-2.76-5.8-3-7.73.55-31.54,1.66-38.16,5.52-19.6,8-26.78,6.9-32.57,6.9-41.68a159.86,159.86,0,0,0-.82-16.29S63.13,328.56,51,323.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.15,467.43A2.94,2.94,0,0,0,88.53,463c-.83-1.1-10.77-4.36-12.42-5.74a3.77,3.77,0,0,1-.68-.78l-.7,4.37a10,10,0,0,1-6.08,2.21c-2.76,0-6.82-1.8-8.55-2.63-.47,4.18-1.45,8.36-.28,9.25C65.43,474,84.94,468.26,87.15,467.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,448.51c-.08-5.28.7-31.08,1.71-37.13,1.1-6.63,5.52-19.6,8-26.78s6.9-32.57,6.9-41.68a159.86,159.86,0,0,0-.82-16.29S63.13,328.56,51,323.87c0,0-1.66,11,0,16.56s6.07,13.26,7.18,15.46,2.48,9.11,2.48,10.49,1.1,17.67-.55,25.95-3.59,13-3.59,21c0,5.67,1.94,24.12,3.07,34.14A42.31,42.31,0,0,0,69.21,449,16,16,0,0,0,73,448.51Z",
    style: {
      fill: "#0D6EFD",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.55,450.92A15.58,15.58,0,0,0,65.34,452c3.31,0,8.28.82,8-.83a48.87,48.87,0,0,1,.27-7.18s-6.07.83-9.66.28-5.79-.83-5.79-.83S58.72,449.27,59.55,450.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.18,258.17a21.23,21.23,0,0,0-11.32-7.45c-7.45-1.93-14.63,9.11-16.56,15.18s-2.21,22.36-5,30.64-4.69,24.85-3.59,26.78,24.85,8,33.13,8S96,324.7,96.26,321.39,94.88,296,93.5,284.12,82.18,258.17,82.18,258.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,350s-.09,3.83,0,6.08a18.86,18.86,0,0,1-.84,6.08c-.47,1.49-1.59,2.52-1.68,1.49s.37-2.9.37-3.74-.28-4.67-.28-4.67a41.87,41.87,0,0,1-.84,4.11c-.56,2.15-2.15,4.39-2.9,4.58s-1.22-.47-.84-1.49,1.31-4,1.4-4.68S73,355,73,355a53.58,53.58,0,0,1-2.52,6.26c-.75,1.13-.84,1.69-1.59,1.78s-.65-1.5-.19-2.71a37.85,37.85,0,0,0,1.22-5.52c0-.37-.84,1.68-1.87,2.81s-1.78,2.05-2.25,1.87.19-2,.57-2.81a12.58,12.58,0,0,0,.93-3.08v-2.43s-.84-1.88,3.09-2.53S77.66,347.24,78.5,350Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,347.34A3.4,3.4,0,0,0,66,351.2c2.06,1.38,9.41,2.49,11.76.28a6.66,6.66,0,0,0,2.35-4.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,261.48s-6.07,9.94-6.07,16.29-3.32,50.79-3.59,56.32.27,9.93,3.59,12.69,16.83,2.76,20.42,1.38,6.9-7.73,6.9-12.14-4.14-37-5-43.34-1.11-23.19-3.59-27.05-3.32-4.15-3.32-4.15",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,324.09s1.69-38.47,3-46.32a56.48,56.48,0,0,1,4.53-14.3",
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,263.83s4.77,9.17,5,19,3.59,41.25,3.59,41.25",
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.91,
    y1: 273.35,
    x2: 82.73,
    y2: 267.83,
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualData);
export default __webpack_public_path__ + "static/media/visual-data.2ab4e73f53c1d7896f3ddf554d43073b.svg";
export { ForwardRef as ReactComponent };